export default function TrustStrip() {
  return (
    <div className="bg-gray-100 py-4">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-center space-x-8 text-[#1e3a5f]">
          <div className="flex items-center space-x-2">
            <i className="ri-map-pin-line text-[#FF6B35] text-xl"></i>
            <span className="text-sm font-semibold">Serving NJ</span>
          </div>
          <div className="w-1 h-1 bg-[#FF6B35] rounded-full"></div>
          <div className="flex items-center space-x-2">
            <i className="ri-map-pin-line text-[#FF6B35] text-xl"></i>
            <span className="text-sm font-semibold">Serving PA</span>
          </div>
          <div className="w-1 h-1 bg-[#FF6B35] rounded-full"></div>
          <div className="flex items-center space-x-2">
            <i className="ri-map-pin-line text-[#FF6B35] text-xl"></i>
            <span className="text-sm font-semibold">Serving MD</span>
          </div>
        </div>
      </div>
    </div>
  );
}
